<div
  class="tw-reset tw-relative tw-mx-4 tw-grid tw-h-dvh tw-place-items-center md:tw-mx-0"
>
  <div
    class="tw-absolute tw-top-14 tw-w-full tw-max-w-[488px] tw-rounded-2xl tw-bg-white tw-p-6 tw-pb-4 tw-shadow-xl md:tw-p-6"
    role="dialog"
  >
    <h4 class="tw-mb-4 tw-font-extrabold tw-text-neutral-800">
      {{ translate('Request Peer Rating', 'dgTagRating_PeerRatings') }}
    </h4>
    <div class="tw-pb-8 tw-pt-4">
      <button
        class="tw-btn-small tw-btn-tertiary"
        data-dgat="peer-rating-overview-modal-47e"
        attr.aria-label="{{
          translate('Request Peer Rating', 'dgTagRating_RequestPeerRating')
        }}"
        (click)="openPeerRequestModal($event)"
      >
        <da-icon icon="plus-small" type="outline" class="tw-w-4"></da-icon>
        {{ translate('Request Peer Rating', 'dgTagRating_RequestPeerRating') }}
      </button>
    </div>
    @if (isLoading()) {
      <dgx-skeleton type="table" [columns]="3" [rows]="10"></dgx-skeleton>
    } @else {
      <div class="tw-flex tw-w-full tw-flex-col">
        @for (rating of pendingRatings(); track rating) {
          <div
            class="tw-flex tw-w-full tw-place-items-center tw-justify-between"
            tabindex="0"
          >
            <div class="tw-flex tw-max-w-56">
              <dgx-user-search-item-v3
                [disableTabbing]="true"
                [item]="rating.rater"
              ></dgx-user-search-item-v3>
            </div>
            <div class="tw-flex tw-gap-4">
              @if (isOwner()) {
                <button
                  class="tw-btn-small tw-btn-tertiary tw-col-span-2 tw-self-center"
                  [attr.aria-label]="
                    translate('Cancel Request', 'dgTagRating_CancelRequest')
                  "
                  (click)="onCancelRequest($event, rating)"
                  data-dgat="peer-rating-overview-modal-76a"
                >
                  {{ translate('Cancel Request', 'dgTagRating_CancelRequest') }}
                </button>
              }

              <div class="tw-w-full tw-self-center tw-text-end">
                <span class="tw-badge-small tw-badge-yellow">
                  {{ translate('Pending', 'Core_Pending') }}
                </span>
              </div>
            </div>
          </div>
        }

        @for (rating of completedRatings(); track rating) {
          <div
            class="tw-flex tw-w-full tw-place-items-center tw-justify-between"
            [class]="{ 'tw-cursor-pointer': isOwner() && rating.rater }"
            (click)="openCompletedRatingModal($event, rating)"
            (keydown)="onKeyDown($event, rating)"
            tabindex="0"
          >
            <div class="tw-flex tw-max-w-56">
              <dgx-user-search-item-v3
                [disableTabbing]="true"
                [item]="rating.rater"
              ></dgx-user-search-item-v3>
            </div>

            <div
              class="tw-flex tw-self-center tw-text-end tw-text-xs tw-font-extrabold"
            >
              {{ itemLevels().get(rating.userTagRatingId) }}
            </div>
          </div>
        }
      </div>
    }

    <div class="tw-flex tw-w-full tw-justify-end tw-gap-4 tw-pt-6">
      <button
        type="button"
        class="tw-btn-medium tw-btn-secondary-filled"
        data-dgat="tag-peer-cancel-rating-57f"
        [attr.aria-label]="translate('Cancel', 'Core_Cancel')"
        (click)="cancel()"
        data-dgat="peer-rating-overview-modal-e88"
      >
        {{ translate('Cancel', 'Core_Cancel') }}
      </button>
      <button
        type="button"
        class="tw-btn-primary tw-btn-medium"
        data-dgat="peer-rating-overview-modal-e22"
        [attr.aria-label]="submitButtonLabel()"
        (click)="openPeerRequestModal($event)"
      >
        {{ submitButtonLabel() }}
      </button>
    </div>
  </div>
</div>
